import { alpha } from '@material-ui/core/';
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    replyPaper: {
        padding: theme.spacing(2.5),
        marginBottom: theme.spacing(3),
        backgroundColor: "#f2f2f2",
    },
}));
  